import { BreadcrumbProps } from '@blueprintjs/core'
import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import { Filters, TableName } from '../../config'
import { useKdpFilters } from '../../hooks/useKdpFilters'
import { TableProps } from '../ad_groups/AdGroupsTable'
import { Layout } from '../Layout'
import { Columns, ExpandedPerformanceMetrics } from '../table2/ad_grid_columns'
import { AgGridColumnDef, AgGridTable } from '../table2/AgGridTable'

const defaultFilters = [Filters.PortfolioId, Filters.State, Filters.ExpressionType]

const mutableFields: string[] = ['state']

interface NegativeTarget {
    target_id: number
    campaign_id: number
    ad_group_id: number
    profile_id: number
    expression_type: number
    state: number
    bid: number
}

export const NegativeTargetsTable = observer(
    ({
        nested,
        store,
        savedFiltersStore,
        tableHooks,
    }: TableProps<NegativeTarget & ExpandedPerformanceMetrics>): JSX.Element => {
        const filters = useKdpFilters(defaultFilters)

        const breadcrumbs: BreadcrumbProps[] = [{ text: 'Manage' }]

        const cols3 = useMemo(() => {
            return newColumns()
        }, [])

        return (
            <Layout
                breadcrumbs={breadcrumbs}
                primary={TableName.NegativeTarget}
                nested={nested}
                params={tableHooks.params}
            >
                <AgGridTable
                    name={TableName.NegativeTarget}
                    columns={cols3}
                    tableHooks={tableHooks}
                    store={store}
                    showHeader={false}
                    savedFiltersStore={savedFiltersStore}
                    filters={filters}
                    selectKey="target_id"
                    stableRowId
                    search
                    searchPlaceholder="Search by target"
                    columnSelection
                    mutableFields={mutableFields}
                    bulkActions
                    nested={nested}
                />
            </Layout>
        )
    },
)

const newColumns = <T,>(): AgGridColumnDef<T>[] => {
    const cols: AgGridColumnDef<T>[] = [Columns.Select, Columns.Parent, Columns.TargetingExpression]

    return cols
}
